import { Box, BoxProps } from '@mui/material'
import { SlideType } from '../../../_types'
import { useWindowDimensions } from '../Jumbotron'

export interface ImageSlideProps extends BoxProps {
  slide: SlideType
  fit?: boolean
  isMobile?: boolean
  isLandscape?: boolean
}
export const ImageSlide: React.FC<ImageSlideProps> = ({
  slide,
  fit,
  isLandscape,
}) => {
  return (
    <Box
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        backgroundColor: '#59595b',
        height: isLandscape ? '100vh' : '95%',
        maxHeight: isLandscape ? '100vh' : '95%',
        alignItems: 'center',
      }}
    >
      <img alt="" src={slide.imgSrc} width={fit ? '100%' : undefined} />
    </Box>
  )
}

export const LandscapeImageScreen: React.FC<ImageSlideProps> = ({
  slide,
}) => {
  const { width, height } = useWindowDimensions()
  return (
    <Box
      style={{
        width,
        minHeight: 0.66 * height,
        backgroundImage: `url(${slide?.imgSrc})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        backgroundPosition: 'center',
        backgroundColor: '#59595b',
      }}
    />
  )
}

export const ImageScreen: React.FC<ImageSlideProps> = ({ slide, isMobile }) => {
  const { width, height } = useWindowDimensions()
  return (
    <Box
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Box
        style={{
          width,
          minHeight: !isMobile ? 0.66 * height : height,
          backgroundImage: `url(${slide?.imgSrc})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          backgroundPosition: 'center',
          backgroundColor: '#59595b',
        }}
      />
    </Box>
  )
}

export default ImageSlide
